import React from 'react';
import PropTypes from 'prop-types';
import JourneyProp from '../../journey/propTypes/journeyProp';

export default function JourneyItemImage({ journey }) {
  const journeyImage = journey && journey.image ? journey.image.url : null;
  return (
    <div className="col-lg-3 col-md-3">
      {journeyImage && (
        <img
          alt="journey avatar"
          className="image-journey"
          src={journeyImage}
        />
      )}
    </div>
  );
}

JourneyItemImage.propTypes = {
  journey: PropTypes.shape(JourneyProp.propType).isRequired,
};
